var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-file container"},_vm._l((_vm.posts),function(p){return _c('PostLine',{key:p.internal_url,attrs:{"post":p}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }